import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingDown, FiDollarSign, FiUsers, FiMessageSquare, FiBarChart, FiClock, FiTarget, FiSettings, FiUserX, FiEyeOff, FiXCircle, FiAlertTriangle } = FiIcons;

const PainPointsSection = () => {
  const painPoints = [
    { icon: FiTrendingDown, text: "Struggling to get consistent leads" },
    { icon: FiDollarSign, text: "Spending money on ads but no ROI" },
    { icon: FiUsers, text: "Agencies overpromise & underdeliver" },
    { icon: FiMessageSquare, text: "Manual follow-ups leading to 90% lost customers" },
    { icon: FiBarChart, text: "No proper sales system or pipeline tracking" },
    { icon: FiClock, text: "Customer inquiries are missed" },
    { icon: FiTarget, text: "Too much competition" },
    { icon: FiSettings, text: "No automation = owner is doing everything" },
    { icon: FiUserX, text: "Employees not performing" },
    { icon: FiEyeOff, text: "No branding or online presence" },
    { icon: FiXCircle, text: "Not able to convert visitors into buyers" },
    { icon: FiAlertTriangle, text: "No time for marketing" }
  ];

  return (
    <section className="py-20 bg-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Ccircle cx='7' cy='7' r='7'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            The Hard Reality Every <span className="text-red-400">MSME Owner</span> Faces Today…
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {painPoints.map((point, index) => (
            <motion.div
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 hover:bg-gray-800/70 transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02, y: -5 }}
            >
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0 p-3 bg-red-500/20 rounded-lg">
                  <SafeIcon icon={point.icon} className="w-6 h-6 text-red-400" />
                </div>
                <p className="text-gray-200 font-medium">{point.text}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="bg-gradient-to-r from-red-500/10 to-orange-500/10 border border-red-500/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <p className="text-2xl lg:text-3xl font-bold text-white leading-relaxed">
              "You started this business to <span className="text-yellow-400">grow</span>… not to chase leads, messages, agencies, and employees all day."
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PainPointsSection;